import React from 'react';
import { Tag } from '@umu/design-base';
import { lang } from '@umu/ukit-lang';
import { classSet } from '@umu/umu-dom';
import { UserAvatar } from 'businessCommon/src/components';
import { INVITE_SCORE_STATUS_MAP } from 'businessCommon/src/components/inviteEvaluationList/constants';
import {
    EInviteScoreStatus,
    EPracticeInviteStatus,
    IPracticeInviteUserList,
} from 'businessCommon/src/components/inviteEvaluationList/types';
import './mobileInviteCard.scss';

interface MobileInviteCardProps {
    record: IPracticeInviteUserList;
    handleToInviteComment: (record: IPracticeInviteUserList, status: EPracticeInviteStatus) => void;
}

// 练习邀请点评
const MobileInviteCard: React.FC<MobileInviteCardProps> = ({ record, handleToInviteComment }) => {
    const { user_info: userInfo, invite_status, is_manager } = record || {};
    const inviteStatusLabel = INVITE_SCORE_STATUS_MAP[invite_status];
    const isManager = +is_manager === 1;
    const isReviewed = invite_status === EInviteScoreStatus.REVIEWED;
    const scoreStr = isReviewed ? record.score : lang('未评分');

    const renderInviteButton = (status: EPracticeInviteStatus, label: string) => (
        <div
            className={classSet({
                'info-desc': true,
                'btn': true,
                'disabled': isReviewed,
            })}
            onClick={() => handleToInviteComment(record, status)}
        >
            {label}
        </div>
    );

    return (
        <div className="invite-evaluation-list-card-wrapper">
            <div className="invite-evaluation-list-user-info">
                <div className="invite-evaluation-list-user-info__left">
                    <UserAvatar src={userInfo.avatar} className="" width={36} />
                </div>
                <div className="invite-evaluation-list-user-info__right">
                    <div className="department-name-group">
                        {userInfo.department_names.map((name) => (
                            <div className="department-name_item" key={name}>
                                {name}
                            </div>
                        ))}
                    </div>
                    <div className="user-info">
                        {isManager && (
                            <div className="user-tag">
                                <Tag style={{ color: '#fab400' }} color="black">
                                    {lang('经理')}
                                </Tag>
                            </div>
                        )}
                        <div className="user-name">{userInfo.name}</div>
                    </div>
                    <div className="user-email">{userInfo.email}</div>
                </div>
            </div>
            <div className="invite-evaluation-list-options">
                <div className="invite-options-wrapper">
                    <div className="info-desc">{inviteStatusLabel}</div>
                    {invite_status !== EInviteScoreStatus.INVITED &&
                        renderInviteButton(EPracticeInviteStatus.INVITE, lang('邀请'))}
                    {invite_status !== EInviteScoreStatus.NOT_INVITED &&
                        renderInviteButton(EPracticeInviteStatus.CANCEL_INVITE, lang('撤回'))}
                </div>
                <div className="info-score">
                    {lang('评分：')}
                    {scoreStr}
                </div>
            </div>
        </div>
    );
};

export { MobileInviteCard };
